import type { ChecklistEntry, InspectionItem, ReportLanguage } from '../../types';
import { pruefpunktText } from '../../services/checklistSprache';

// ─── n.i.O.-Prüfpunkt → Mangel (Checklistenmodus am Handy) ──────────────────

/**
 * Titelvorschlag für den Mangel aus einem n.i.O.-Prüfpunkt.
 *
 * Ein Prüfpunkt ist ein SOLLSATZ („Baustelleneinrichtungsplan liegt vor").
 * Wörtlich als Mangeltitel übernommen, stünde im Bericht unter „Offen" genau
 * das Gegenteil dessen, was vor Ort festgestellt wurde. Deshalb „Nicht erfüllt:"
 * davor — im Assistenten bleibt der Titel änderbar.
 *
 * Englische Berichte bekommen „Not fulfilled:" und den Punkt der
 * Standard-Checkliste englisch (checklistSprache); „de/en" bleibt deutsch wie
 * der Prüfpunkttext. Steht der Vorsatz schon da (eigener Punkt), kommt er nicht
 * doppelt. Leerer Prüfpunkt → leerer Titel: dann tippt der Prüfer selbst.
 */
export function nioMangelTitel(pruefpunkt: string, sprache?: ReportLanguage): string {
    const text = pruefpunktText((pruefpunkt || '').trim(), sprache);
    if (!text) return '';
    const vorsatz = sprache === 'en' ? 'Not fulfilled:' : 'Nicht erfüllt:';
    if (text.toLowerCase().startsWith(vorsatz.toLowerCase())) return text;
    return `${vorsatz} ${text}`;
}

/** Vorbelegung des Mangel-Assistenten aus einem n.i.O.-Prüfpunkt. */
export function nioMangelVorlage(eintrag: ChecklistEntry, sprache?: ReportLanguage): Partial<InspectionItem> {
    return {
        title: nioMangelTitel(eintrag.text, sprache),
        observation: eintrag.comment || '',
        status: 'open',
        sectionId: eintrag.sectionId,
    };
}
